var map = {
	"./": 481,
	"./OldUi": 2637,
	"./OldUi.js": 2637,
	"./SpireonNew": 2638,
	"./SpireonNew.js": 2638,
	"./SpireonOld": 2639,
	"./SpireonOld.js": 2639,
	"./index": 481,
	"./index.js": 481,
	"./style": 369,
	"./style.js": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4113;